// documentPaymentKeys.js

export const DOCUMENT_PAYMENT_TYPE_KEY = 'DOCUMENT_PAYMENT';
export const DOCUMENT_PAYMENT_DATA_SECTION = 'data_document_payment';

export const DOCUMENT_PAYMENT_PARENT_TYPE_KEYS = Object.freeze([
  'INVOICE',
  'PROPOSAL',
]);

/**
 * @param {unknown} typeKey
 * @returns {boolean}
 */
export function isDocumentPaymentTypeKey(typeKey) {
  return String(typeKey || '').trim().toUpperCase() === DOCUMENT_PAYMENT_TYPE_KEY;
}

/**
 * @param {unknown} typeKey
 * @returns {boolean}
 */
export function isDocumentPaymentParentTypeKey(typeKey) {
  const normalized = String(typeKey || '').trim().toUpperCase();
  return DOCUMENT_PAYMENT_PARENT_TYPE_KEYS.includes(normalized);
}
